export default {
  cookies: {
    weUseCookies: 'Wir verwenden Cookies bei der Bereitstellung unserer Dienste.',
    learnMoreStart: 'Um mehr über die von uns verwendeten Cookies und Informationen zu Ihren Präferenzen und Opt-Out-Optionen zu erfahren, ',
    learnMoreClickHere: 'klicken Sie bitte hier',
    learnMoreEnd: '.',
    decline: 'Abfall',
    allow: 'Erlauben',
    showPrivacyPolicy: 'Datenschutzbestimmungen anzeigen'
  }
};